import React, { createRef, useState, useCallback, useEffect } from 'react';

const Autocomplete = ({
  className,
  value,
  placeholder = '',
  disabled = false,
  readOnly = false,
  highlightText = false,
  onChange,
  onSelect,
  onBlur
}) => {
  const activeElementRef = createRef();
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cursor, setCursor] = useState(0);

  const setOption = useCallback((option) => {
    setOptions([]);
    onSelect(option.value || option);
  }, [onSelect]);

  const handleKeyDown = (e) => {
    const scrollToActive = () => {
      activeElementRef && activeElementRef.current.scrollIntoView({ block: 'center' });
    };

    const keys = { enter: 13, up: 38, down: 40 };
    if (e.keyCode === keys.enter && options.length > 0 && !isNaN(cursor)) {
      e.preventDefault();
      setOption(options[cursor]);
    }
    else if (e.keyCode === keys.up && cursor > 0) {
      e.preventDefault();
      setCursor(cursor - 1);
      scrollToActive();
    }
    else if (e.keyCode === keys.down && cursor < options.length - 1) {
      e.preventDefault();
      setCursor(cursor + 1);
      scrollToActive();
    }
  };

  const handleChange = useCallback((e) => {
    setCursor(0);
    setLoading(true);
    setInputValue(e.target.value);
    onChange(e, values => {
      setOptions(values);
      setLoading(false);
    });
  }, [onChange]);

  useEffect(() => {
    handleChange({ target: { value } });
  }, [value, handleChange]);

  return (
    <>
      <input type="text"
        className={className}
        value={inputValue}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={onBlur}
        onChange={handleChange}
        onKeyDown={handleKeyDown} />
      {loading && <i className='icon icon--loader'></i>}
      {options.length > 0 && (
        <ul className='autocomplete'>
          {options.map((option, i) => (
            <li
              key={i}
              ref={cursor === i ? activeElementRef : null}
              className={`autocomplete__item ${cursor === i ? 'item--active' : ''}`}
              onClick={() => setOption(option)}>
              {highlightText && inputValue.length > 0 && option.text.toLowerCase().includes(inputValue.toLowerCase()) ? (<>
                {option.text.slice(0, option.text.toLowerCase().indexOf(inputValue.toLowerCase()))}
                <strong>{option.text.slice(option.text.toLowerCase().indexOf(inputValue.toLowerCase()), option.text.toLowerCase().indexOf(inputValue.toLowerCase()) + inputValue.length)}</strong>
                {option.text.slice(option.text.toLowerCase().indexOf(inputValue.toLowerCase()) + inputValue.length)}
              </>) : option.text}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default Autocomplete;
